import { Type } from 'class-transformer';
import { BaseParameterDto } from './base-parameter-dto';
import { RegistrationParameterDto } from './registration/registration-parameter-dto';

export class CreateUserParameterDto extends BaseParameterDto {
  email: string;
  confirmEmail: string;
  password: string;
  customerID: string;
  checkDigit: number;
  recaptchaToken: string;

  @Type(() => RegistrationParameterDto)
  contactInfo: RegistrationParameterDto;
}
